import React from "react";
import "../../styles/Footer.css";
//import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <div className="footer w-full flex justify-center">
      <div className="flex flex-col w-full max-w-5xl">
        <div className="copyright pt-9 pl-5 flex flex-col ">
          <span>
            Copyright &#169; {new Date().getFullYear()} &nbsp; | &nbsp; Pange
            Studios &nbsp; <br />{" "}
          </span>

          <span>
            Questions or Comments?{" "}
            <a
              style={{ color: "white" }}
              href="mailto:andrewhopgood.exp@gmail.com"
            >
              andrewhopgood.exp@gmail.com
            </a>{" "}
          </span>
        </div>
      </div>
    </div>
  );
}

/*

const scrollTop = () => {
    window.scrollTo(0, 0);
  };
  
<div className="site-map-title h-1/5 pt-3 pl-3">Site Map {">"}</div>
        <div className="h-3/5 flex flex-col justify-center pb-5 pl-3">
          <div className="w-full flex">
            <Link to="/" className="w-1/2 site-map">
              Home
            </Link>
            <Link
              to="/ON/common-forms"
              className="w-1/2 site-map"
              onClick={scrollTop}
            >
              Common Forms
            </Link>
          </div>
          <div className="w-full flex ">
            <Link
              to="/ON/transaction-checklists"
              className="w-1/2 site-map"
              onClick={scrollTop}
            >
              Transaction Checklists
            </Link>

            <Link
              to="/ON/understanding-tresa"
              className="w-1/2 site-map"
              onClick={scrollTop}
            >
              TRESA Best Practices
            </Link>
          </div>
          <div className="w-full flex">
            <Link
              to="/ON/form-320"
              className="w-1/2 site-map"
              onClick={scrollTop}
            >
              FORM 320: CoC Checkboxes
            </Link>
            <Link
              to="/ON/office-procedures"
              className="w-1/2 site-map"
              onClick={scrollTop}
            >
              Office Procedures
            </Link>
          </div>
        </div>



*/
